import { Badge, Table } from "@mantine/core";

import type { CptByPrefixRow } from "../../services/reports.service";

interface PrefixCodeTableProps {
  rows: CptByPrefixRow[];
}

export function PrefixCodeTable({ rows }: PrefixCodeTableProps) {
  return (
    <Table striped highlightOnHover withTableBorder>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Prefix</Table.Th>
          <Table.Th>CPT / Report Code</Table.Th>
          <Table.Th ta="right">Count Total</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {rows.flatMap((prefix) =>
          prefix.breakdown.map((code, index) => (
            <Table.Tr key={`${prefix.prefixId}:${code.cptCode}`}>
              {index === 0 && (
                <Table.Td rowSpan={prefix.breakdown.length}>
                  {prefix.prefixCode}
                </Table.Td>
              )}
              <Table.Td>
                <Badge variant="outline">{code.cptCode}</Badge>
              </Table.Td>
              <Table.Td ta="right">{code.count}</Table.Td>
            </Table.Tr>
          ))
        )}
      </Table.Tbody>
    </Table>
  );
}
